import Vue from 'vue'
const downsampler = (function () {
  let result = null;
  return function (time, func) {
    if (!result) {
      result = setTimeout(function () {
        func();
        result = null;
      }, time);
    }
  }
})();

//滚动到头部
Vue.directive('scrolltop', {
  bind: (el, binding) => {
    // 是否执行回调事件
    let eventAction = true
    // 监听滚动事件
    el.onscroll = (e) => {
       if ((typeof binding.value === 'function') && e.target.scrollTop<30&&e.target.scrollTop>0) {
        // 执行事件回调函数
        // binding.value()
        downsampler(1000, binding.value);
        eventAction = false
      }  else if (e.target.scrollTop>0) {
        eventAction = true
      }
    }
  }
})

// input框只能是正数，小数点1位
Vue.directive('limitInput', {
	bind(el) {
		let input = el.getElementsByTagName('input')[0];
		input.onkeyup = function() {
			input.value = input.value.match(/^\d*(\.?\d{0,1})/g)[0].replace(/\-/g, '').replace(/" "/g, '');
		};
	}
});

//复制粘贴指令
Vue.directive('paste',{
  bind(el,binding,vnode) {
    el.addEventListener('paste',function(event){ //这里直接监听元素的粘贴事件
      binding.value(event)
    })
  }
})

Vue.directive('drag',{
  bind(el,binding,vnode) {
   //因为拖拽还包括拖动时的经过事件，离开事件，和进入事件，放下事件，浏览器对于拖拽的默认事件的处理是打开拖进来的资源，所以要先对这三个事件进行默认事件的禁止
    el.addEventListener('dragenter',function(event){
      event.stopPropagation();
      event.preventDefault();
    })
    el.addEventListener('dragover',function(event){
      event.stopPropagation();
      event.preventDefault();
    })
    el.addEventListener('dragleave',function(event){
      event.stopPropagation();
      event.preventDefault();
    })
    el.addEventListener('drop',function(event){ //这里阻止默认事件，并绑定事件的对象，用来在组件上返回事件对象
      event.stopPropagation();
      event.preventDefault();
      binding.value(event)
    })
  }
})//拖拽释放指令
